import { useRef, useState } from "react";
import { Loader2, Upload } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { ConfirmarAccion } from "@/components/migracion/ConfirmarAccion";
import { api, apiError } from "@/lib/api";

export function PasoSubir({ enCurso, onValidado }) {
  const ref = useRef(null);
  const [archivo, setArchivo] = useState(null);
  const [subiendo, setSubiendo] = useState(false);

  const elegir = (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    if (!f.name.toLowerCase().endsWith(".xlsx")) return toast.error("Sube un archivo .xlsx (la plantilla).");
    if (f.size > 10 * 1024 * 1024) return toast.error("El archivo pasa de 10 MB.");
    setArchivo(f);
  };

  const validar = async () => {
    const fd = new FormData();
    fd.append("archivo", archivo);
    setSubiendo(true);
    try {
      const r = await api.post("/migracion-cartera/lotes", fd);
      const cr = r.data.creditos || {};
      toast.success(`Archivo validado: ${r.data.filas_nuevas} clientes nuevos, ${r.data.filas_vinculadas} vinculados, ${r.data.filas_error} con error`
        + (cr.total ? ` · ${cr.validos} créditos válidos, ${cr.error} con error.` : "."));
      onValidado(r.data.lote_id);
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setSubiendo(false);
      setArchivo(null);
    }
  };

  return (
    <section className="rounded-lg border border-slate-200 bg-white p-5" data-testid="migracion-paso-subir">
      <p className="text-xs font-semibold uppercase tracking-wide text-slate-400">Paso 2</p>
      <h2 className="mt-1 text-base font-semibold text-slate-900">Subir archivo</h2>
      <p className="mt-1 text-sm text-slate-600">Archivo .xlsx de hasta 10 MB y 500 filas por hoja. Validar no crea ningún cliente ni crédito.</p>
      {enCurso && (
        <p className="mt-3 rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-800" data-testid="migracion-en-curso-aviso">
          Hay una migración en curso
        </p>
      )}
      <input ref={ref} type="file" accept=".xlsx" className="hidden" onChange={elegir} data-testid="migracion-input-archivo" />
      <Button size="sm" className="mt-3 gap-2" disabled={enCurso || subiendo} onClick={() => ref.current?.click()}
        data-testid="migracion-subir-archivo">
        {subiendo ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />}
        Subir archivo
      </Button>
      <ConfirmarAccion
        abierto={!!archivo}
        onCerrar={() => setArchivo(null)}
        titulo="Validar archivo"
        accion="Validar archivo"
        onConfirmar={validar}
        testid="migracion-confirmar-validar"
      >
        Se revisará fila por fila «{archivo?.name}» ({Math.ceil((archivo?.size || 0) / 1024)} KB). Verás el resumen antes de
        confirmar; en este paso no se crea ni se vincula ningún cliente ni crédito.
      </ConfirmarAccion>
    </section>
  );
}
